import { Button, buttonVariants, Link } from '@/components';
import { CardFooter } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { faEdit, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function KalenderCardActions({
  kalenderId,
  onDelete,
}: {
  kalenderId: string;
  onDelete?: (kalenderId: string) => void;
}) {
  const { t } = useTranslation();
  const editLabel = t('domain.termine.edit');
  const deleteLabel = t('domain.termine.delete');

  return (
    <CardFooter className="px-4 pb-4 pt-0 justify-start gap-2">
      <Link
        aria-label={editLabel}
        title={editLabel}
        className={cn(
          buttonVariants({ variant: 'ghost', size: 'icon' }),
          'hover:bg-transparent',
        )}>
        <FontAwesomeIcon
          icon={faEdit}
          className="text-primary-blue-600 w-4 h-4"
        />
      </Link>
      <Button
        variant="ghost"
        size="icon"
        className="hover:bg-transparent"
        aria-label={deleteLabel}
        title={deleteLabel}
        onClick={() => onDelete?.(kalenderId)}>
        <FontAwesomeIcon
          icon={faTrashCan}
          className="text-primary-red-400 w-4 h-4"
        />
      </Button>
    </CardFooter>
  );
}
